export default () => ENV.RELEASE_STAGE === 'development' ? 'https://static.hypotheekbond.test/' : 'https://static.hypotheekbond.nl/';
